
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Obtenir et utiliser des avis clients pour votre entreprise",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment collecter des avis clients positifs et les intégrer efficacement dans votre stratégie de communication digitale pour renforcer votre image.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment obtenir et utiliser vos avis clients",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique comment collecter des avis clients positifs et les utiliser dans votre communication digitale.",
        },
      ],
    };
  },
};
